<template>
  <v-layout column fill-height>
    <breadcrumbs
      v-on:selectTab="changeTab"
      :guia="guia"
      titulo="Relatório de Clientes"
      descricao=" Faça download da relação de clientes por status."
      :tabs="tabOptions"
    />

    <v-layout class="main">
      <v-flex v-if="tab == 1">
        <v-layout row class="content-header">
          <v-flex md12 class="content-title">
            <h2>Ativos</h2>
            <h4>Consulte relatórios dos clientes ativos por período</h4>
          </v-flex>
        </v-layout>
        <v-layout row class="content-body">
          <v-flex md12>
            <ativos v-if="relSegAtivos" />
            <div v-else>
              <v-alert type="info">{{messageRelatorio}}</v-alert>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="tab == 2">
        <v-layout row class="content-header">
          <v-flex md12 class="content-title">
            <h2>Cancelados</h2>
            <h4>Consulte relatórios dos clientes cancelados por período.</h4>
          </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
          <v-flex md12>
            <cancelados v-if="relCancelados" />
            <div v-else>
              <v-alert type="info">{{messageRelatorio}}</v-alert>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="tab == 3">
        <v-layout row class="content-header">
          <v-flex md12 class="content-title">
            <h2>Cobrados</h2>
            <h4>Consulte relatórios dos clientes com parcelas pagas por período.</h4>
          </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
          <v-flex md12>
            <cobrados v-if="relCobrados" />
            <div v-else>
              <v-alert type="info">{{messageRelatorio}}</v-alert>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="tab == 4">
        <v-layout row class="content-header">
          <v-flex md12 class="content-title">
            <h2>Inadimplentes</h2>
            <h4>Consulte relatórios dos clientes com parcelas em aberto por período.</h4>
          </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
          <v-flex md12>
            <inadimplentes v-if="relInadimplentes" />
            <div v-else>
              <v-alert type="info">{{messageRelatorio}}</v-alert>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="tab == 5">
        <v-layout row class="content-header">
          <v-flex md12 class="content-title">
            <h2>A Vencer</h2>
            <h4>Consulte relatórios dos clientes com pagamento a vencer nos próximos 90 dias.</h4>
          </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
          <v-flex md12>
            <aVencer v-if="relAvencer" />
            <div v-else>
              <v-alert type="info">{{messageRelatorio}}</v-alert>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>


<script>
import breadcrumbs from "@/components/portal/layout/Breadcrumbs";
import ativos from "@/components/portal/relatorios/geral/Ativos";
import aVencer from "@/components/portal/relatorios/geral/AVencer";
import cancelados from "@/components/portal/relatorios/geral/Cancelados";
import cobrados from "@/components/portal/relatorios/geral/Cobrados";
import inadimplentes from "@/components/portal/relatorios/geral/Inadimplentes";
import Vue from "vue";

export default {
  components: {
    breadcrumbs,
    ativos,
    cancelados,
    cobrados,
    inadimplentes,
    aVencer
  },
  data() {
    return {
      tab: 1,
      guia: "Relatórios > Ativos",
      tabOptions: [
        { id: 1, titulo: "Ativos" },
        { id: 2, titulo: "Cancelado" },
        { id: 3, titulo: "Cobrados" },
        { id: 4, titulo: "Inadimplentes" },
        { id: 5, titulo: "A Vencer" }
      ],
      relatoriosEmExecucao: [],
      relAvencer: true,
      relInadimplentes: true,
      relSegAtivos: true,
      relCancelados: true,
      relCobrados: true,
      messageRelatorio:'Olá! Neste momento estamos realizando a atualização diária dos dados e, em alguns minutos, esta funcionalidade estará disponível novamente para consulta.'
    };
  },
  async created() {
    await this.relatorioEmExecucao();
    this.statusRelatorio();
  },
  methods: {
    async relatorioEmExecucao() {
      this.loading = true;
      this.fullLoading = true;
      await Vue.prototype.$httpPortal
        .get("Relatorio/EmExecucao")
        .then(res => {
          this.relatoriosEmExecucao = res.data;
          this.loading = false;
          this.fullLoading = false;
        })
        .catch(ex => {
          console.log(ex);
          this.loading = false;
          this.fullLoading = false;
        });
    },
    statusRelatorio() {
      this.relatoriosEmExecucao.forEach(element => {
        if (element.Nome.trim() == "COBRADOS" && element.Executando == 1)
          this.relCobrados = false;
        else if (element.Nome.trim() == "CANCELADO" && element.Executando == 1)
          this.relCancelados = false;
        else if (element.Nome.trim() == "INADIMPLENTES" && element.Executando == 1)
          this.relInadimplentes = false;
        else if (element.Nome.trim() == "SEG_ATIVOS" && element.Executando == 1)
          this.relSegAtivos = false;
        else if (element.Nome.trim() == "VENCER" && element.Executando == 1)
          this.relAvencer = false;
      });
    },
    changeTab(value) {
      this.tab = value;
      this.guia = "Relatórios > " + this.tabOptions[value - 1].titulo;
    }
  }
};
</script>